/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-09 11:39:10
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Tabs } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import ListingTab from './listing-tab';
import DetailTab from './detail-tab';
import SwatchSettingsTab from './swatch-settings-tab';
import ProductLabelTab from './product-label-tab';
import Preview from './preview';

type Props = WithI18nProps;

type State = {
  selected: number
};

class ProductItemTab extends Component<Props, State> {
  state = {
    selected: 0
  };

  render() {
    const { i18n } = this.props;
    const { selected } = this.state;

    const tabs = [
      {
        id: 'listing',
        content: i18n.translate('AdminHTML.DefaultThemeSettings.ProductItemTab.tab1_Content'),
        panelID: 'listing'
      },
      {
        id: 'detail',
        content: i18n.translate('AdminHTML.DefaultThemeSettings.ProductItemTab.tab2_Content'),
        panelID: 'detail'
      },
      {
        id: 'swatch-settings',
        content: i18n.translate('AdminHTML.DefaultThemeSettings.ProductItemTab.tab3_Content'),
        panelID: 'swatch-settings'
      },
      {
        id: 'product-label',
        content: i18n.translate('AdminHTML.DefaultThemeSettings.ProductItemTab.tab4_Content'),
        panelID: 'product-label'
      }
    ];

    const tabComponents = [
      <ListingTab />,
      <DetailTab />,
      <SwatchSettingsTab />,
      <ProductLabelTab />
    ];

    return (
      <div className="BC-Default-Theme-Settings__ProductItem">
        <div className={`settings-content ${selected === 0 ? 'product-list-tab' : 'product-tab'}`}>
          <Tabs tabs={tabs} selected={selected} onSelect={this.handleTabChange}>
            <div className="settings-content-tab">{tabComponents[selected]}</div>
          </Tabs>
        </div>

        <div className={`preview ${selected === 0 ? 'product-list-tab' : 'product-tab'}`}>
          <Preview selected={selected} />
        </div>
      </div>
    );
  }

  // Handle change tab
  handleTabChange = (selectedTabIndex: number) => {
    this.setState({ selected: selectedTabIndex });
  };
}

export default withI18n()(ProductItemTab);
